import { FC, useState } from "react"

import PillTabs from "../../../pill-tabs"
import RateAlertsTable from "./table/rate-alerts"
import IntroTable from "./table/intro"
import QuoteReceiptTable from "./table/quote-receipt"
import UnsubscribedTable from "./table/unsubscribed"

export enum EmailStatsTabs {
  RATE_ALERTS = "by-rate-alerts",
  INTRO_EMAILS = "by-intro-emails",
  UNSUBSCRIBED = "by-unsubscribed",
  QUOTE_RECEIPT = "by-quote-receipt"
}

enum EmailStatsLabelTabs {
  RATE_ALERTS = "Rate alerts",
  INTRO_EMAILS = "Intro emails",
  UNSUBSCRIBED = "Unsubscribed",
  QUOTE_RECEIPT = "Quote receipt"
}

interface EmailStatsProps {
  title: string
  range: number
  orgId: string | undefined
  loid: string | undefined
}

const EmailStats: FC<EmailStatsProps> = ({ title, range, orgId, loid }) => {
  const [tab, setTab] = useState<string>(EmailStatsTabs.RATE_ALERTS)

  return (
    <div className="bg-white flex flex-col flex-1 rounded-xl border border-slate-200 shadow-sm px-6 py-5 overflow-hidden transition-shadow duration-200 hover:shadow-md">
      <div className="flex flex-col md:flex-row items-center justify-between mb-6">
        <div className="w-full md:w-auto mb-4 md:mb-0">
          <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
        </div>
        <div className="flex">
          <PillTabs
            currentTab={tab}
            className=""
            navigationClassName="flex-wrap justify-center gap-1 rounded-full bg-slate-100 p-1 md:flex-nowrap md:justify-end"
            commontabClassName="whitespace-nowrap px-4 py-1.5 !rounded-full text-sm leading-relaxed cursor-pointer transition-colors text-slate-500 hover:text-slate-700"
            activeTabClassName="bg-white text-slate-900 shadow-sm hover:text-slate-900"
            defaultTabClassName=""
            tabs={[
              {
                id: EmailStatsTabs.RATE_ALERTS,
                label: EmailStatsLabelTabs.RATE_ALERTS
              },
              {
                id: EmailStatsTabs.INTRO_EMAILS,
                label: EmailStatsLabelTabs.INTRO_EMAILS
              },
              {
                id: EmailStatsTabs.QUOTE_RECEIPT,
                label: EmailStatsLabelTabs.QUOTE_RECEIPT
              },
              {
                id: EmailStatsTabs.UNSUBSCRIBED,
                label: EmailStatsLabelTabs.UNSUBSCRIBED
              }
            ]}
            onChange={setTab}
          />
        </div>
      </div>
      {tab === EmailStatsTabs.RATE_ALERTS && (
        <RateAlertsTable range={range} orgId={orgId} loid={loid} />
      )}
      {tab === EmailStatsTabs.INTRO_EMAILS && (
        <IntroTable range={range} orgId={orgId} loid={loid} />
      )}
      {tab === EmailStatsTabs.QUOTE_RECEIPT && (
        <QuoteReceiptTable range={range} orgId={orgId} loid={loid} />
      )}
      {tab === EmailStatsTabs.UNSUBSCRIBED && (
        <UnsubscribedTable range={range} orgId={orgId} loid={loid} />
      )}
    </div>
  )
}

export default EmailStats
